export default function SectionApp() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-3xl overflow-hidden border border-background-200/70">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-16">
              <span className="inline-block text-xs font-medium text-primary-500 tracking-wider uppercase mb-3 whitespace-nowrap">
                Mobile
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4">
                随时随地，吃瓜不停
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md">
                每日大赛mrds移动端专属入口，让你无论身在何处都能第一时间追踪最新爆料和热点排行。
                更流畅的浏览体验，更快捷的投票通道，吃瓜排位赛随时参与。
              </p>
              <div className="flex flex-wrap items-center gap-3">
                <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-full font-medium text-sm cursor-pointer transition-colors hover:bg-foreground-800 whitespace-nowrap">
                  <i className="ri-apple-fill"></i>
                  <span>App Store 下载</span>
                </div>
                <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm cursor-pointer transition-colors hover:bg-primary-600 whitespace-nowrap">
                  <i className="ri-google-play-fill"></i>
                  <span>Google Play 下载</span>
                </div>
              </div>
            </div>
            <div className="flex-1 w-full max-w-[420px] lg:max-w-none">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20a%20modern%20entertainment%20news%20app%20interface%2C%20ranking%20list%20with%20warm%20red%20accents%2C%20trending%20topics%20cards%2C%20clean%20mobile%20UI%20design%2C%20pop%20art%20editorial%20style%2C%20crimson%20and%20gold%20color%20scheme%2C%20dark%20mode%20phone%20screen%2C%20no%20text%2C%20modern%20device%20frame&width=600&height=700&seq=mrds-app-01&orientation=portrait"
                alt="每日大赛mrds移动端界面展示"
                className="w-full h-auto object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}